import { render, staticRenderFns } from "./ResultTotalRanking.vue?vue&type=template&id=25ed34aa&"
import script from "./ResultTotalRanking.vue?vue&type=script&lang=js&"
export * from "./ResultTotalRanking.vue?vue&type=script&lang=js&"
import style0 from "./ResultTotalRanking.vue?vue&type=style&index=0&id=25ed34aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports